import React from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";
import Button from "../../../components/ui/Button";

const FeaturedProjects = () => {
  const featuredProjects = [
    {
      id: 1,
      title: "受注発送管理データベース",
      description:
        "贈答品の受注受付から発送までのデータを一括管理 業務効率化でキーボード入力を出来るだけ簡略化します。",
      image:
        "https://portfolio.cue-lock.jp/image-folder/close-up_zoom_of_hands_exchanging_a_gift.png",
      technologies: ["Claris FileMaker Pro"],
      category: "",
      status: "",
      liveUrl: "#",
      githubUrl: "#",
      featured: true,
    },
    {
      id: 2,
      title: "伝統的建造物群管理データベース",
      description:
        "伝統的建造物群の情報を一元管理し、関係者間での情報共有を円滑にするためのデータベースです。",
      image:
        "https://portfolio.cue-lock.jp/image-folder/traditional_Edo-period_street_in_old_Gero_lined.png",
      technologies: ["Claris FileMaker Pro"],
      category: "",
      status: "",
      liveUrl: "#",
      githubUrl: "#",
      featured: true,
    },
    {
      id: 3,
      title: "同窓会管理データベース",
      description:
        "同窓生の情報を一元管理し、イベントの企画や連絡を円滑にするためのデータベースです。",
      image:
        "https://portfolio.cue-lock.jp/image-folder/close-up_of_a_class_reunion_invitation_card.png",
      technologies: ["Claris FileMaker Pro"],
      category: "",
      status: "",
      liveUrl: "#",
      githubUrl: "#",
      featured: true,
    },
  ];

  const handleScrollToProjects = () => {
    const projectsSection = document.getElementById("projects");
    if (projectsSection) {
      projectsSection?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="featured-projects" className="py-20 bg-background">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-accent/10 text-accent rounded-full text-sm font-medium mb-4">
            <Icon name="Star" size={16} className="mr-2" />
            Featured Work
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            制作実績
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Claris FileMaker Pro
            を活用したシステム開発の一部をご紹介します。これまでに30以上のプロジェクトを手掛け、様々な業界のニーズに応えてきました。
          </p>
        </div>

        {/* Projects Grid */}
        <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-8 mb-12">
          {featuredProjects?.map((project, index) => (
            <div
              key={project?.id}
              className="group bg-card rounded-2xl overflow-hidden shadow-elevation-sm hover:shadow-elevation-lg transition-layout hover-lift"
              style={{ animationDelay: `${index * 200}ms` }}
            >
              {/* Project Image */}
              <div className="relative h-48 overflow-hidden">
                <Image
                  src={project?.image}
                  alt={project?.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-layout"
                />

                {/* Status Badge */}
                <div className="absolute top-4 left-4">
                  <span
                    className={`px-3 py-1 rounded-full text-xs font-medium ${
                      project?.status === "Completed"
                        ? "bg-success/20 text-success"
                        : "bg-warning/20 text-warning"
                    }`}
                  >
                    {project?.status}
                  </span>
                </div>

                {/* Category Badge */}
                <div className="absolute top-4 right-4">
                  <span className="px-3 py-1 bg-primary/20 text-primary rounded-full text-xs font-medium">
                    {project?.category}
                  </span>
                </div>

                {/* Overlay with Links */}
                {/* <div className="absolute inset-0 bg-foreground/80 opacity-0 group-hover:opacity-100 transition-micro flex items-center justify-center space-x-4">
                  <Button
                    variant="secondary"
                    size="sm"
                    iconName="ExternalLink"
                    iconPosition="left"
                    className="bg-card text-foreground hover:bg-muted"
                  >
                    Live Demo
                  </Button>
                  <Button
                    variant="outline"
                    size="sm"
                    iconName="Github"
                    iconPosition="left"
                    className="bg-card text-foreground border-border hover:bg-muted"
                  >
                    Code
                  </Button>
                </div> */}
              </div>

              {/* Project Content */}
              <div className="p-6">
                <h3 className="text-xl font-semibold text-foreground mb-2 group-hover:text-primary transition-micro">
                  {project?.title}
                </h3>

                <p className="text-text-secondary mb-4 line-clamp-3">
                  {project?.description}
                </p>

                {/* Technologies */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {project?.technologies?.slice(0, 4)?.map((tech) => (
                    <span
                      key={tech}
                      className="px-2 py-1 bg-muted text-text-secondary rounded text-xs font-medium"
                    >
                      {tech}
                    </span>
                  ))}
                  {project?.technologies?.length > 4 && (
                    <span className="px-2 py-1 bg-muted text-text-secondary rounded text-xs font-medium">
                      +{project?.technologies?.length - 4} more
                    </span>
                  )}
                </div>

                {/* Project Links */}
                {/* <div className="flex items-center justify-between">
                  <div className="flex space-x-2">
                    <button className="p-2 text-text-secondary hover:text-primary transition-micro hover:bg-muted rounded-lg">
                      <Icon name="ExternalLink" size={16} />
                    </button>
                    <button className="p-2 text-text-secondary hover:text-primary transition-micro hover:bg-muted rounded-lg">
                      <Icon name="Github" size={16} />
                    </button>
                  </div>

                  <button className="text-sm text-primary hover:text-primary/80 font-medium transition-micro">
                    Learn More →
                  </button>
                </div> */}
              </div>
            </div>
          ))}
        </div>

        {/* View All Projects CTA */}
        {/* <div className="text-center">
          <Button
            variant="outline"
            size="lg"
            onClick={handleScrollToProjects}
            iconName="ArrowRight"
            iconPosition="right"
            className="hover-lift"
          >
            View All Projects
          </Button>
        </div> */}
      </div>
    </section>
  );
};

export default FeaturedProjects;
